<template>
  <tr>
    <td>
      <el-popover v-if="! editMode"
        placement="top"
        :width="$store.state.customLabels === 'medspa' ? 150 : 86"
        trigger="hover"
      >
        <div style="margin: 0">
          <div class="btn-group btn-group-sm" role="group" aria-label="Basic example">
            <button class="btn btn-warning btn-outline"
              @click="openStockRotationModal(1)"
            >
              <i class="fas fa-plus"></i>
            </button>
            <button class="btn btn-warning btn-outline"
              @click="openStockRotationModal(-1)"
            >
              <i class="fas fa-minus"></i>
            </button>
          </div>
          <el-dropdown trigger="click" v-if="$store.state.customLabels === 'medspa'">
            <button class="btn btn-primary btn-outline btn-sm" style="margin-left: 8px;">
              <i class="fas fa-money-check"></i> <i class="el-icon-arrow-down el-icon--right"></i>
            </button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <a class="dropdown-item" :href="`${api}/products/${product ? product.id : ''}/custom_label/small`"
                  target="_blank"
                >
                  38x11mm
                </a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a class="dropdown-item" :href="`${api}/products/${product ? product.id : ''}/custom_label/medium`"
                  target="_blank"
                >
                  28x51mm
                </a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a class="dropdown-item" :href="`${api}/products/${product ? product.id : ''}/custom_label/large`"
                  target="_blank"
                >
                  57x32mm
                </a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <router-link :to="`/products/${product.id}`" slot="reference">
          {{ product.name }}
        </router-link>
      </el-popover>
      <input v-else class="form-control" v-model="productToEdit.name">
    </td>
    <td>
      <a href="#" v-if="product.product_category && ! editMode" @click.prevent="$emit('filterProductCategory', product.product_category)"
      >
        {{ product.product_category.name }}
      </a>
      <multiselect v-model="productToEdit.product_category"
        :options="productCategories"
        track-by="id"
        label="name"
        v-if="editMode"
      />
    </td>
    <td>
      <span v-if="! editMode">{{ product.hersteller }}</span>
      <input v-else class="form-control" v-model="productToEdit.hersteller">
    </td>
    <td>
      <router-link :to="`/suppliers/${cheapestSupplier.supplier.id}`"
        v-if="cheapestSupplier"
      >
        {{ cheapestSupplier.supplier.name }}
      </router-link>
      <div v-else class="text-center nowrap">
        <button class="btn btn-link btn-xs btn-primary"
          @click="openAssignToSuppliersDialog"
        >
          <i class="fas fa-plus"></i><i class="fas fa-truck"></i>
        </button>
      </div>
    </td>
    <td>
      <span v-if="product.unit && ! editMode">{{ product.unit.name }}</span>
      <multiselect v-model="productToEdit.unit"
        :options="units"
        track-by="id"
        label="name"
        v-if="editMode"
      />
    </td>
    <td class="text-right">
      <span v-if="! editMode || cheapestSupplier">{{ cheapestPrice | priceFromCentEuro }}</span>
      <price-input :price="productToEdit.standard_price" class="quick-input"
        v-else
        @input="productToEdit.standard_price = $event"
      />
    </td>
    <td class="text-right">
      <span v-if="! editMode">{{ product.price | priceFromCentEuro }}</span>
      <input class="form-control quick-input" v-else :value="price" @input="price = $event.target.value">
    </td>
    <td class="text-right">{{ product.quantity }}</td>
    <td class="text-right">{{ product.quantity * product.price | priceFromCentEuro }}</td>
    <td class="text-right">{{ product.quantity_sold || 0 }}</td>
    <td class="nowrap">{{ product.latest_in || '' | datetime }}</td>
    <td class="nowrap">{{ product.latest_out || '' | datetime }}</td>
    <td class="nowrap">{{ product.next_expiry_date | date }}</td>
    <td class="text-center" v-if="showWarehouses">
      <a class="btn btn-info btn-link btn-xs"
         @click="$emit('openWarehouses', product)">
        <i class="fas fa-warehouse"></i>
      </a>
    </td>
    <td>
      <div v-if="product.thumbnail_path && product.path">
        <img style="width: 50px;"
          :src="baseUrlWithoutApi +'/storage/' + product.thumbnail_path"
          alt="Product Image"
          @click="showImage(product.path)"
        />
      </div>
      <div v-else>
      </div>
          </td>
    <td class="text-right">
      <div class="td-actions">
        <template v-if="!onlyShowAction && !editMode">
          <button class="btn btn-warning btn-link btn-xs"
            v-tooltip.top-center="'Bearbeiten'"
            @click="enterEditMode"
          >
            <i class="fas fa-edit"></i>
          </button>
          <a v-tooltip.top-center="'Löschen'" class="btn btn-danger btn-link btn-xs"
            @click="$emit('deleteProduct', product)"
          >
            <i class="fa fa-close"></i>
          </a>
        </template>
        <template v-if="editMode">
          <div class="edit-mode-actions">
            <button class="btn btn-success btn-link btn-xs"
              v-tooltip.top-center="'Speichern'"
              @click="saveEdit"
            >
              <i class="fas fa-check"></i>
            </button>
            <button class="btn btn-danger btn-link btn-xs"
              v-tooltip.top-center="'Cancel'"
              @click="exitEditMode"
            >
              <i class="fa fa-close"></i>
            </button>
          </div>
        </template>
      </div>
    </td>
    <div v-if="showImageModal">
      <div class="modal-bg" @click="closeImageModal"></div>
      <div class="modal-content">
        <img :src="baseUrlWithoutApi +'/storage/' + enlargedImagePath" alt="Enlarged Image" />
      </div>
    </div>
  </tr>
</template>

<script>
import api from 'src/api'
import { groupNewestSuppliers } from 'src/util/helpers'
import priceWatcher from 'src/pages/Products/price-watcher'
import cloneDeep from 'lodash/cloneDeep'
import PriceInput from 'src/components/price-input'
import baseApiUrl from '@/api.js';

import { Popover, Dropdown, DropdownItem, DropdownMenu } from 'element-ui'

export default {
  props: ['product', 'onlyShowAction', 'showWarehouses', 'editMode', 'productCategories', 'units'],
  mixins: [priceWatcher],
  components: {
    PriceInput,
    [Popover.name]: Popover,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data () {
    return {
      api,
      productToEdit: null,
      showImageModal: false,
    }
  },
  methods: {
    enterEditMode () {
      this.productToEdit = cloneDeep(this.product)
      this.$emit('enterEditMode', this.product)
    },
    exitEditMode () {
      this.productToEdit = null
      this.$emit('exitEditMode', this.product)
    },
    saveEdit () {
      this.$emit('saveEdit', this.productToEdit)
    },
    getPrice () {
      return this.productToEdit.price
    },
    setPrice (price) {
      this.productToEdit.price = price
    },
    openAssignToSuppliersDialog () {
      this.$emit('openAssignToSuppliersDialog', this.product)
    },
    openStockRotationModal (direction) {
      this.$emit('openStockRotationModal', {
        direction,
        product: this.product
      })
    },
    showImage(path) {
      this.showImageModal = true;
      this.enlargedImagePath = path;
    },
    closeImageModal() {
      this.showImageModal = false;
      this.enlargedImagePath = '';
    }
  },
  computed: {
    productSuppliers () {
      return groupNewestSuppliers(this.product.suppliers)
    },
    cheapestSupplier () {
      return this.productSuppliers.length ? this.productSuppliers[0] : false
    },
    cheapestPrice () {
      return this.product.einkaufspreis
    },
    baseUrlWithoutApi() {
      const apiIndex = baseApiUrl.lastIndexOf('/api');

      return apiIndex !== -1 ? baseApiUrl.substring(0, apiIndex) : baseApiUrl;
    },
  }
}
</script>

<style scoped>
  .edit-mode-actions .btn {
    opacity: 1 !important;
  }
  .el-popover {
    min-width: 86px;
  }
  .quick-input {
    min-width: 60px;
  }
  .td-actions {
    min-width: 50px;
  }
  .modal-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.modal-content {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1001;
  width: 30%;
}
</style>
